import { UIDataModel, UIComponentHandler, UIComponentState } from '../../toolkit/uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../toolkit/uicomponentcss';
import { HomeWrapperViewImpl } from './homewrapperview';
import { HomeWrapperCSSStyleImpl } from './homewrappercss';
import { MainWrapperComponentProps, MainWrapperComponent } from '../mainwrappercomponent';
import { CategoryDto } from '../../../core/dto/categories/categorydto';
import { ToolbarSearchAPIModel, ToolbarSearchAPIModelImpl } from '../../toolkit/toolbarwithsearch/toolbarsearchapimodel';
import { APIFeatures } from '../../../core/util/apifeatures';
import { APIModelHandler, APIModel } from '../../toolkit/uicomponentapimodel';

export interface HomeWrapperComponentProps extends MainWrapperComponentProps
{
    searchKey: string;
    signIn(): void;
    onSearch(searchKey: string): void;
}

export interface HomeWrapperComponentState extends UIComponentState
{
    categories: CategoryDto[];
}

export class HomeWrapperComponent extends MainWrapperComponent<HomeWrapperComponentProps, HomeWrapperComponentState>
{
    constructor(props: HomeWrapperComponentProps)
    {
        super(props);

        this.state = {categories: []};
    }

    componentDidMount()
    {
        (this.getAPIModel() as ToolbarSearchAPIModel).getCategories();
        this.props.context.getUserContext().getIsLoggedIn() && 
        (this.getAPIModel() as ToolbarSearchAPIModel).getPackStatusAPI();
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
       if(feature === APIFeatures.CATEGORIES)
        {
            this.setState({categories: data as CategoryDto[]});
        }
    }
   
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ToolbarSearchAPIModelImpl(applicationContext, apiModelHandler);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new HomeWrapperViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new HomeWrapperCSSStyleImpl(applicationContext);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/homewrappercomponent.tsx